/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from './encoder';
import { Observable }                                        from 'rxjs';

// import { JsonListContainerPlikDto } from '../model/models';
// import { JsonObjectContainerMultimediaSzczegolyDto } from '../model/models';
// import { RequestErrorResponse } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from './variables';
// import { ModulMultimediowPublicConfiguration }                                     from './configuration';
import { JsonListContainerPlikDto } from '../modele/json-list-container-plik-dto';
import { JsonObjectContainerMultimediaSzczegolyDto } from '../modele/json-object-container-multimedia-szczegoly-dto';
import { ModulMultimediowPublicConfiguration } from './configuration-modul-multimediow';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ControllerMultimediaOpenService {

    protected basePath = environment.portalMultimediaApiUrl+'';
    public defaultHeaders = new HttpHeaders();
    public configuration = new ModulMultimediowPublicConfiguration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: ModulMultimediowPublicConfiguration) {
        // if (configuration) {
        //     this.configuration = configuration;
        // }
        // if (typeof this.configuration.basePath !== 'string') {
        //     if (typeof basePath !== 'string') {
        //         basePath = this.basePath;
        //     }
        //     this.configuration.basePath = basePath;
        // }
        this.configuration.basePath = basePath;
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param zrodloDanychMVC
     * @param nazwaMVC
     * @param idObiektu
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pobierzListePlikowPoZrodleDanychIMVC(zrodloDanychMVC: string, nazwaMVC: string, idObiektu: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json'}): Observable<JsonListContainerPlikDto>;
    public pobierzListePlikowPoZrodleDanychIMVC(zrodloDanychMVC: string, nazwaMVC: string, idObiektu: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json'}): Observable<HttpResponse<JsonListContainerPlikDto>>;
    public pobierzListePlikowPoZrodleDanychIMVC(zrodloDanychMVC: string, nazwaMVC: string, idObiektu: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json'}): Observable<HttpEvent<JsonListContainerPlikDto>>;
    public pobierzListePlikowPoZrodleDanychIMVC(zrodloDanychMVC: string, nazwaMVC: string, idObiektu: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*' | 'application/json'}): Observable<any> {
        if (zrodloDanychMVC === null || zrodloDanychMVC === undefined) {
            throw new Error('Required parameter zrodloDanychMVC was null or undefined when calling pobierzListePlikowPoZrodleDanychIMVC.');
        }
        if (nazwaMVC === null || nazwaMVC === undefined) {
            throw new Error('Required parameter nazwaMVC was null or undefined when calling pobierzListePlikowPoZrodleDanychIMVC.');
        }
        if (idObiektu === null || idObiektu === undefined) {
            throw new Error('Required parameter idObiektu was null or undefined when calling pobierzListePlikowPoZrodleDanychIMVC.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<JsonListContainerPlikDto>(`${this.basePath}/open/multimedia/${encodeURIComponent(String(zrodloDanychMVC))}/${encodeURIComponent(String(nazwaMVC))}/${encodeURIComponent(String(idObiektu))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param zrodloDanychMVC
     * @param nazwaMVC
     * @param idObiektu
     * @param nazwa
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pobierzPlik1(zrodloDanychMVC: string, nazwaMVC: string, idObiektu: number, nazwa: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<string>>;
    public pobierzPlik1(zrodloDanychMVC: string, nazwaMVC: string, idObiektu: number, nazwa: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<string>>>;
    public pobierzPlik1(zrodloDanychMVC: string, nazwaMVC: string, idObiektu: number, nazwa: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<string>>>;
    public pobierzPlik1(zrodloDanychMVC: string, nazwaMVC: string, idObiektu: number, nazwa: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (zrodloDanychMVC === null || zrodloDanychMVC === undefined) {
            throw new Error('Required parameter zrodloDanychMVC was null or undefined when calling pobierzPlik1.');
        }
        if (nazwaMVC === null || nazwaMVC === undefined) {
            throw new Error('Required parameter nazwaMVC was null or undefined when calling pobierzPlik1.');
        }
        if (idObiektu === null || idObiektu === undefined) {
            throw new Error('Required parameter idObiektu was null or undefined when calling pobierzPlik1.');
        }
        if (nazwa === null || nazwa === undefined) {
            throw new Error('Required parameter nazwa was null or undefined when calling pobierzPlik1.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/open/multimedia/pliki/${encodeURIComponent(String(zrodloDanychMVC))}/${encodeURIComponent(String(nazwaMVC))}/${encodeURIComponent(String(idObiektu))}/${encodeURIComponent(String(nazwa))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param zrodloDanychMVC
     * @param nazwaMVC
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pobierzSzczegolyPoZrodleDanychIMVC(zrodloDanychMVC: string, nazwaMVC: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json'}): Observable<JsonObjectContainerMultimediaSzczegolyDto>;
    public pobierzSzczegolyPoZrodleDanychIMVC(zrodloDanychMVC: string, nazwaMVC: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json'}): Observable<HttpResponse<JsonObjectContainerMultimediaSzczegolyDto>>;
    public pobierzSzczegolyPoZrodleDanychIMVC(zrodloDanychMVC: string, nazwaMVC: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json'}): Observable<HttpEvent<JsonObjectContainerMultimediaSzczegolyDto>>;
    public pobierzSzczegolyPoZrodleDanychIMVC(zrodloDanychMVC: string, nazwaMVC: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*' | 'application/json'}): Observable<any> {
        if (zrodloDanychMVC === null || zrodloDanychMVC === undefined) {
            throw new Error('Required parameter zrodloDanychMVC was null or undefined when calling pobierzSzczegolyPoZrodleDanychIMVC.');
        }
        if (nazwaMVC === null || nazwaMVC === undefined) {
            throw new Error('Required parameter nazwaMVC was null or undefined when calling pobierzSzczegolyPoZrodleDanychIMVC.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<JsonObjectContainerMultimediaSzczegolyDto>(`${this.basePath}/open/multimedia/${encodeURIComponent(String(zrodloDanychMVC))}/${encodeURIComponent(String(nazwaMVC))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
